import React from "react";
import Contact from "../../common/Contact/Contact";
import FooterThree from "../../common/Footer/FooterThree";
import Menu from "./Menu";
import ServiceDetailsAbout from "./ServiceDetailsAbout";
import ServiceDetailsBanner from "./ServiceDetailsBanner";

const SapientCreative = () => {
  return (
    <>
      <Menu header_style_2={true} />
      <ServiceDetailsBanner />
      <ServiceDetailsAbout />
      <Contact />
      <FooterThree />
    </>
  );
};

export default SapientCreative;
